import { DialogComponent } from './../components/shared/dialog/dialog.component';
import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
} from '@angular/core';
import { DialogOptions } from '@components/shared/dialog/dialog.interface';

@Injectable({ providedIn: 'root' })
export class DialogService {
  private componentRef!: ComponentRef<DialogComponent>;
  private dialogOptions!: DialogOptions;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef
  ) {}

  openDialog(dialogOptions: DialogOptions) {
    this.dialogOptions = dialogOptions;
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(DialogComponent);

    const componentRef = componentFactory.create(this.injector);
    componentRef.instance.showModal = true;
    componentRef.instance.textContent = dialogOptions.textContent;
    componentRef.instance.textHeader = dialogOptions.textHeader;
    componentRef.instance.showBtnOk = dialogOptions.showBtnOk;
    componentRef.instance.showCloseBtn = dialogOptions.showClose;
    componentRef.instance.textHandleOk = dialogOptions.textHandleOk;
    componentRef.instance.dismissableMask = dialogOptions.dismisable;
    componentRef.instance.handleOk$.subscribe(() => {
      this.dialogOptions?.onClose?.call(null);
    });
    componentRef.instance.handleClose$.subscribe(() => {
      this.dialogOptions?.onReject?.call(null);
    });

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }

  close(): void {
    this.componentRef.instance.handleClose();
    this.dialogOptions.onClose!.call(null);
    this.appRef.detachView(this.componentRef.hostView);
    this.componentRef.destroy();
  }
}
